<template>
  <div>
    <div>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <!-- <div>
            <span>平台账户集余额:</span>
             <span style="color: red;">	总额:{{(platform.allAmount /100).toFixed(2)}} 元</span>
             <span style="color: red;">	冻结额:{{(platform.freezeAmount /100).toFixed(2)}} 元</span>
         </div>
          <div>
             收银宝商户资金:
             <span style="color: red;">{{(vps.balance /100).toFixed(2)}} 元</span>
             <small style="color: blue;">(当天账户收款实时总金额)</small>
          </div> -->
          <el-button style="float: right; padding: 3px 0" type="text" onclick="location.reload()">刷新页面  <i class="el-icon-refresh"></i></el-button>
        </div>
        <el-row :gutter="24">
          <el-col :span="3">
            <el-input placeholder="商家id"  v-model="params.merchant_id" size="mini">
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="店铺id"  v-model="params.distributor_id" size="mini">
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-input placeholder="订单号" v-model="params.order_id" style="width: 100%" size="mini"></el-input>
          </el-col>
          <el-col :span="3">
            <el-select v-model="params.order_status" clearable size="mini" placeholder="订单状态">
              <el-option v-for="item in orderArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select v-model="params.settle_accounts_status" clearable size="mini" placeholder="结算状态">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <!--  -->
          <el-col :span="3">
            <el-select v-model="params.verify" size="mini" clearable placeholder="审核状态">
              <el-option v-for="item in verifyArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select v-model="params.account_status" size="mini" clearable placeholder="账单状态">
              <el-option v-for="item in statusArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          </el-row>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-select v-model="params.belong_billing_date"  clearable style="width: 100%" size="mini" placeholder="归属账期">
                <el-option v-for="item in paymentList" :key="item.belong_billing_date" :label="item.belong_billing_date"
                  :value="item.belong_billing_date">
                </el-option>
              </el-select>
            </el-col>

          <el-col :span="20">
            <div class="block">
              <el-date-picker size="mini" v-model="params.times" type="daterange" :picker-options="pickerOptions"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
              </el-date-picker>
                 <el-button type="primary" @click="searchData" size="mini">搜索</el-button>
 <el-button type="danger" size="mini" icon="plus" @click="upAccountFile('update')">更新通联对账数据</el-button>
              <el-button type="primary" size="mini" icon="plus" @click="getExport(0)">下载对账汇总</el-button>
               <el-button type="primary" size="mini" icon="plus" @click="getExport(1)">下载对账汇总(按交易)</el-button>
              <el-button type="primary" size="mini" icon="plus" @click="fileExport()">下载通联对账</el-button>
              <el-tooltip content="可选择时间段" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </el-col>

        </el-row>

        <el-row :gutter="24">
          <el-col>
            <!-- <el-dropdown @command="toVerify">
              <el-button type="success"  size="mini">
                批量审核<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  command="1">通过</el-dropdown-item>
                <el-dropdown-item  command="2">不通过</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->

            <!-- <el-button-group> -->
                <!-- <el-button type="warning" size="mini" icon="plus" @click="batchPay()">批量托管代付</el-button> -->
            <!-- </el-button-group> -->
            <!-- getExport -->

            <el-dropdown @command="upAccountFile">
              <el-button type="primary"  size="mini">
                下载通联对账文件<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  command="1">对账明细TXT</el-dropdown-item>
                <el-dropdown-item  command="2">对账汇总TXT</el-dropdown-item>
                <el-dropdown-item  command="3">对账单XLSX</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tooltip content="对账文件只能选择下载某一天的数据" placement="top">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-alert
            title="今日订单于第二天进行自动比对!"
            type="info"
            show-icon>
          </el-alert>
      </el-card>

        <el-card class="box-card"  v-if="checkNumber.order_total">
            <ul>
              <li> <span>选择数量: <span style="color:red;">{{checkNumber.order_total }}</span> </span></li>
              <li>
                <span>
                     通联比对统计:
                     <span style="color:green;">比对成功:{{checkNumber.success}}</span>
                     <span style="color:red;">比对失败:{{checkNumber.fail}}</span>
                     <span style="color:#333;">待比对:{{checkNumber.wait}}</span>
                </span>
              </li>

              <li>
                <span>结算数量:
                <span style="color:green;">已入账:{{checkNumber.accounts_success}}</span>
                <span style="color:red;">未入账:{{checkNumber.accounts_fail}}</span>
                </span>
              </li>
              <li>
                金额总计:
                <span>金额: <span style="color:red;">{{(checkNumber.total_fee/100).toFixed(2) }}</span> 元 </span>
                <span>手续费: <span style="color:red;">{{(checkNumber.fee/100).toFixed(2) }}</span> 元 </span>
              </li>
            </ul>
        </el-card>
      <el-table :data="dataList" @selection-change="handleSelectionChange" :height="wheight - 130" v-loading="loading">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- onePay -->
            <!-- <el-tag size="mini" effect="plain" v-if="scope.row.account_status=0 && scope.row.verify == 1" @click="onePay(scope.row)">单笔托管代付</el-tag> -->
            <el-button size="mini" type="text"  @click="show(scope.row)">明细详情</el-button>
            <el-button size="mini" type="text"  v-if="scope.row.third_status == 'FAIL'" @click="toCheckAccount(scope.row)">重新校对</el-button>
            <!-- toRemarks -->
          </template>
        </el-table-column>
        <el-table-column label="通联对账比对">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.third_status == 'WAIT' ?'info': scope.row.third_status == 'SUCCESS' ?  'success' :'danger'">
              {{ scope.row.third_status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="order_total_fee" label="订单金额">
          <template slot-scope="scope">
            <ul>
              <li> <el-tag type="pramary" size="mini">￥{{ (scope.row.order_total_fee / 100 ).toFixed(2)}}</el-tag></li>
              <li>  <el-tag type="danger" size="mini"  >￥{{(parseInt(scope.row.third_amount)/100) .toFixed(2)}}</el-tag></li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column label="平台应收款">
          <template slot-scope="scope">
            <ul>
              <li><el-tag type="pramary" size="mini">￥{{ (( parseInt(scope.row.platform_service_fee02) + parseInt(scope.row.platform_service_fee01) )/ 100).toFixed(2)}}</el-tag>
            </li>
              <li><el-tag type="danger" size="mini">￥{{(parseInt(scope.row.third_fee)/100) .toFixed(2)}}</el-tag></li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column prop="order_id" label="订单号">
          <template slot-scope="scope">
           <small>{{scope.row.order_id}}</small>
          </template>
        </el-table-column>
        <el-table-column prop="merchant_id" label="商家id">
          <template slot-scope="scope">
           <small>{{scope.row.merchant_id}}</small>
          </template>
        </el-table-column>
         <el-table-column prop="belong_billing_date" label="归属账期">
           <template slot-scope="scope">
            <small>{{scope.row.belong_billing_date}}</small>
           </template>
         </el-table-column>
        <el-table-column prop="order_create_time" label="交易时间">
          <template slot-scope="scope">
           <small>{{scope.row.order_create_time}}</small>
          </template>
        </el-table-column>
        <el-table-column prop="distributor_id" label="店铺id">
          <template slot-scope="scope">
           <small>{{scope.row.distributor_id}}</small>
          </template>
        </el-table-column>
        <el-table-column prop="distributor_name" label="店铺名称">
          <template slot-scope="scope">
           <small>{{scope.row.distributor_name}}</small>
          </template>
        </el-table-column>


       <el-table-column label="商品总价">
         <template slot-scope="scope">
           ￥{{ (scope.row.items_total_fee / 100).toFixed(2) }}
         </template>
       </el-table-column>

        <el-table-column label="配送费">
          <template slot-scope="scope">
            ￥{{ (scope.row.freight_fee / 100 ).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="merchant_receivables" label="商家应收款">
          <template slot-scope="scope">
            ￥{{ (scope.row.merchant_receivables / 100 ).toFixed(2)}}
          </template>
        </el-table-column>
        <el-table-column prop="settle_accounts_status" label="结算状态">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.settle_accounts_status == '未入账'?'info':'success'">
              {{ scope.row.settle_accounts_status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="order_status" label="订单状态">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.order_status == 'CANCEL'?'parmary':'success'">
              {{ scope.row.order_status == 'CANCEL' ?'已退款':'已收款' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column  label="账单类型">
          <template slot-scope="scope">
           <el-tag size="mini" type="danger" v-if="scope.row.account_status_str == '1' ">
             <s>无效账单</s>
            </el-tag>
            <el-tag size="mini" type="success" v-else>
             有效账单
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="verify" label="审核状态">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.verify == '0' ?'warning': scope.row.verify == '1' ?  'success' :'info'">
              {{ scope.row.verify == '0' ?'待审核': scope.row.verify == '1' ? '已通过' :'未通过' }}
            </el-tag>
          </template> -->
        <!-- </el-table-column> -->

      </el-table>
      <div class="content-center content-top-padded">
        <el-pagination background layout="total, sizes, prev, pager, next" @current-change="handleCurrentChange"
          @size-change="handleSizeChange" :current-page.sync="params.page" :page-sizes="[20, 50,100,200]"
          :total="total_count" :page-size="params.pagesize">
        </el-pagination>
      </div>

<el-dialog
  :title="account_title"
  :visible.sync="dialogUpAccountVisible"
  width="30%"
  :before-close="handleClose">
 <div class="block">
     <el-date-picker
       v-model="account_date"
       align="right"
       type="date"
       placeholder="选择日期">
     </el-date-picker>
   </div>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="accountSubmit()">确 定</el-button>
  </span>
</el-dialog>
      <el-dialog
        :title="title2"
        :visible.sync="dialogVisible2"
        width="30%"
        :before-close="handleClose">
         <el-input type="textarea" v-model="remarks"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="toRemarksSubmit()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="详情" width="50%" :visible.sync="dialogFormVisible">
        <el-row>
          <el-row>
            <el-col :span="4">订单号:</el-col>
            <el-col size="mini" :span="7">{{ row.order_id }}</el-col>

            <el-col :span="4">门店名称:</el-col>
            <el-col size="mini" :span="7">{{ row.distributor_name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">商家id:</el-col>
            <el-col size="mini" :span="7">{{ row.merchant_id }}</el-col>
            <el-col :span="4">门店id:</el-col>
            <el-col size="mini" :span="7">{{ row.distributor_id }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">交易时间:</el-col>
            <el-col size="mini" :span="7">{{ row.order_create_time }}</el-col>
            <el-col :span="4">账单日期:</el-col>
            <el-col size="mini" :span="7">{{ row.billing_date }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">归属账期:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">{{ row.belong_billing_date }}</el-tag>
            </el-col>
            <el-col :span="4">结算状态:</el-col>
            <el-col :span="7">
              <el-tag :type="row.settle_accounts_status == '未入账' ? 'info' : 'success'" size="mini">
                {{ row.settle_accounts_status }}
              </el-tag>
            </el-col>
          </el-row>
          <el-row>

            <el-col size="mini" :span="4">商品总价:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.items_total_fee / 100).toFixed(2) }} </el-tag>
            </el-col>
            <el-col size="mini" :span="4" >商家承担配送费:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{(row.merchant_freight_fee/100).toFixed(2)}} </el-tag>
            </el-col>
          </el-row>
          <el-row>
            <el-col size="mini" :span="4">订单状态:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini" :type="row.order_status == 'CANCEL'?'info':'success'">
                {{ row.order_status == 'CANCEL' ?'已退款':'已收款' }}
              </el-tag>
            </el-col>
            <el-col size="mini" :span="4">配送费:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.freight_fee / 100 ).toFixed(2)}} </el-tag>
            </el-col>
          </el-row>
          <el-row>
            <el-col size="mini" :span="4">配送方式:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini" :type="row.is_merchant_delivery == 0 ?'info':'success'">
                {{ row.is_merchant_delivery == 0 ?'平台配送':'商家自配送' }}
              </el-tag>
            </el-col>
            <el-col size="mini" :span="4">用户支付金额: </el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.order_total_fee / 100 ).toFixed(2)}}</el-tag>
              <el-tooltip content="(商品总价 + 用户支付配送费 + 打包费 - 商家会员折扣金额-商家优惠券抵扣金额 - 平台会员折扣金额 - 平台优惠券抵扣金额)" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-col>

          </el-row>
          <el-row>

            <el-col size="mini" :span="4">商家应收款:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.merchant_receivables / 100).toFixed(2) }}</el-tag>
              <el-tooltip v-if="row.is_merchant_delivery == 0" content="(商品总价  + 打包费 - 商家会员折扣金额-商家优惠券抵扣金额 - 平台服务费 - 平台服务费2)"
                placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
              <el-tooltip v-else content=" ( 商品总价 + 用户支付配送费 + 打包费 - 商家会员折扣金额-商家优惠券抵扣金额 - 平台服务费 - 平台服务费2)" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-col>
            <el-col size="mini" :span="4">商家优惠券抵扣金额:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini ">￥{{ (row.merchant_coupon_discount / 100).toFixed(2) }}</el-tag>
            </el-col>
          </el-row>

          <el-row>
            <el-col size="mini" :span="4">平台优惠券抵扣金额:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini ">￥{{ (row.platform_coupon_discount / 100 ).toFixed(2)}}</el-tag>
            </el-col>
            <el-col size="mini" :span="4">商家会员折扣金额:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.merchant_member_discount / 100).toFixed(2) }}</el-tag>
            </el-col>

          </el-row>
          <el-row>
            <el-col size="mini" :span="4">平台会员折扣金额:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.platform_member_discount / 100 ).toFixed(2)}}</el-tag>
            </el-col>
<!-- <el-col size="mini" :span="4">审核状态:</el-col>
            <el-col size="mini" :span="7">
             <el-tag size="mini" :type="row.verify == '0' ?'warning':row.verify == '1' ?  'success' :'info'">
               {{ row.verify == '0' ?'待审核': row.verify == '1' ? '已通过' :'未通过' }}
             </el-tag>
            </el-col> -->
             <el-col size="mini" :span="4">打包费:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.packing_fee / 100 ).toFixed(2)}} </el-tag>
            </el-col>
        <!-- <el-col size="mini" :span="4" v-if="row.order_status=='CANCEL'  " >原云商通订单号／原商户订单号:</el-col>

            <el-col size="mini" :span="7" v-if="row.allinpaylist !=undefined && row.allinpaylist.ori_order_no != undefined && row.allinpaylist.ori_biz_order_no !=undefined">
              <el-tag size="mini">{{row.allinpaylist.ori_order_no}} </el-tag>
              <el-tag size="mini">{{row.allinpaylist.ori_biz_order_no}}</el-tag>
            </el-col> -->
            <el-col size="mini" :span="4">平台应收款:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.platform_service_fee01 / 100).toFixed(2) }} </el-tag>
              <el-tooltip v-if="row.is_merchant_delivery == 0" content=" 平台服务费 + 用户支付配送费"
                placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
              <el-tooltip v-else content=" (商品总价 + 打包费 - 商家活动支出 ) * 费率" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row>
            <el-col size="mini" :span="4">平台服务费:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.platform_fee  / 100).toFixed(2) }} </el-tag>
              <el-tooltip v-if="row.is_merchant_delivery == 0" content=" (商品总价 + 打包费 - 商家活动支出  + 用户支付配送费) * 费率 "
                placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
              <el-tooltip v-else content=" (商品总价 + 打包费 - 商家活动支出 ) * 费率" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row>
            <el-col size="mini" :span="4">平台服务费2:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.platform_service_fee02 / 100 ).toFixed(2)}} </el-tag>
            </el-col>

          </el-row>
          <el-row>
            <el-col size="mini" :span="4">平台服务费保底:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">￥{{ (row.platform_service_base_fee / 100 ).toFixed(2)}} </el-tag>
            </el-col>
          </el-row>
          <el-row>
            <el-col size="mini" :span="4">平台服务费费率:</el-col>
            <el-col size="mini" :span="7">
              <el-tag size="mini">{{ row.platform_service_rate }}% </el-tag>
            </el-col>
        <el-col size="mini" :span="4" v-if="row.remarks">备注:</el-col>
            <el-col size="mini" :span="7" v-if="row.remarks">
              <span><small>{{ row.remarks }}</small></span>
            </el-col>
          </el-row>
        </el-row>
      </el-dialog>

    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import draggable from "vuedraggable";
  import {
    getMerchantAccountChecking,
    getMerchantAccountCheckingExport,
    getMerchantBillingDetailsExport,
    getCheckAccountFile,
    signalAgentPay,
    batchAgentPay,
    getPaymentList,
    VerifyAccount,
    getAccountList,
    getCheckAccountFileExport,
    setAccounFile,
    getQueryMerchantBalance,
    getQueryReserveFundBalance,
    getQueryVSPFund,
    checkAccount,
  } from "../../../api/merchant";
  export default {
    components: {
      draggable
    },
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        dialogVisible2:false,
        dialogUpAccountVisible:false,
        dialogFormVisible: false,
        total_count: 0,
        params: {
          type: 'detail',
          page: 1,
          pagesize: 20,
          times:'',
        },
        dataList: [],
        paymentList: [],
        loading: false,
        id: "",
        row: [],
        checkArr: [],
        checkList:[],
        options: [ {
          value: '未入账',
          label: '未入账'
        }, {
          value: '已入账',
          label: '已入账'
        }],
        orderArr:[{
          value: 'CANCEL',
          label: '已退款'
          },
        {
          value: 'PAYED',
          label: '已收款'
        },
        ],
        statusArr: [{
          value: 0,
          label: '有效账单'
        }, {
          value: 1,
          label: '无效账单'
        }, ],
        verifyArr:[
          {
            value: 0,
            label: '待审核'
          },
          {
            value: 1,
            label: '已通过'
          },
          {
            value: 2,
            label: '未通过'
          },
        ],
        remarks:'',
        title2:'审核',
        accountList:[],
        dialogAccountVisible:false,
        checkNumber:{},
        platform:'',
        balance:0,
        vps:{},
        account_date:'',
        account_title:'',
        account_val:'',

      };
    },
    computed: {
      ...mapGetters(["wheight"]),
    },
    methods: {
      fileExport(){
        if(this.params.times == '' && this.params.belong_billing_date == ''){
          this.$message({
              type: 'error',
              message:'请先选择时间或者账期!'
            });
            return false;
        }
        this.$notify({
          title: '成功',
          message: '正在导出,请稍后...',
          type: 'success'
        })
        getCheckAccountFileExport(this.params).then(res => {
          if (res.data.data.status) {
            this.$notify({
              title: '成功',
              message: '已加入队列!',
              type: 'success'
            })
            if(res.data.data.url){
               var url = res.data.data.url
                window.open(url)
            }
          } else {
            this.$notify({
              title: '失败',
              message: '出错了!',
              type: 'error'
            })
          }
        })
      },
      //export
      getExport(val=0) {
      if(this.params.times == '' && this.params.belong_billing_date == ''){
          this.$message({
              type: 'error',
              message:'请先选择时间或者账期!'
            });
            return false;
        }
        this.$notify({
          title: '成功',
          message: '正在导出,请稍后...',
          type: 'success'
        })
        if(val== 1){
          this.params.bytime=val;
        }
          getMerchantAccountCheckingExport(this.params).then(res => {
            if (res.data.data.status) {
              this.$notify({
                title: '成功',
                message: '已加入队列,请到设置中下载!',
                type: 'success'
              })
              // var url = res.data.data.url
              // window.open(url)
            } else {
              this.$notify({
                title: '失败',
                message: '出错了!',
                type: 'error'
              })
            }
          })

      },
      checkAccountFile(val) {
        this.dialogUpAccountVisible=true;
        this.account_title="对账数据下载";

        getCheckAccountFile({date:this.account_date,filetype:val}).then(res => {
          if (res.data.data.status) {
            this.$notify({
              title: '成功',
              message: '正在下载请稍后!',
              type: 'success'
            })
            var url = res.data.data.data.url
            window.open(url)
          } else {
            this.$notify({
              title: '失败',
              message: res.data.data.msg,
              type: 'error'
            })
          }
        })
      },
      upAccountFile(val){
         if(val=='update'){
           // accountSubmit
           this.account_title="通联对账数据更新"
         }else{
           this.account_title="通联对账数据"
         }
          this.dialogUpAccountVisible=true;
          this.account_val=val
      },
      accountSubmit(){
        if(this.account_val == 'update'){
          //更新对账列表
          setAccounFile({date:this.account_date}).then((res) => {
            this.$message({
                type: 'success',
                message: res.data.data.msg
              });
            })
        }else{
          this.checkAccountFile(this.account_val);
        }

      },
      getMerchantFee() {
        this.platform={
           allAmount:0,freezeAmount:0,
        };
        getQueryMerchantBalance({}).then((res) => {
          if (res.data.data.status == true) {
             this.platform = res.data.data.data
          }
        })
      },

       handleClose(done) {
              this.$confirm('确认关闭？')
                .then(_ => {
                  done();
                })
                .catch(_ => {});
      },
      toVerify(verify){
        //审核
        var msg=verify== 1 ?'通过':'不通过';
        this.$prompt('请输入备注!', '批量审核:'+msg, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '备注不能为空!'
        }).then(({ value }) => {
          VerifyAccount({
            ids: this.checkArr,
            verify:verify,
            remarks:value,
          }).then(res => {
            this.$notify({
              title: '提示',
              message: res.data.data.msg,
              type: 'success'
            })
           setTimeout(()=>{
             this.params.page=1;
             this.getDataList();
           },2000)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      toRemarks(row){
        //备注
        this.row=row;
        this.dialogVisible2=true;
        this.remarks=row.remarks;
        this.title2=row.order_id+'订单备注'
      },

      getPaymentList() {
        getPaymentList({}).then((res) => {
          if (res.data.data) {
            this.paymentList = res.data.data
          }
        })
      },
      batchPay() {
        this.$confirm('是否确认批量代付?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          batchAgentPay({
            ids: this.checkArr
          }).then(res => {
            this.$notify({
              title: '提示',
              message: res.data.data.msg,
              type: 'success'
            })
          })
        }).catch(() => {});
      },
      onePay(row) {
        this.$confirm('是否确认代付?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          signalAgentPay({
            order_id: row.order_id
          }).then(res => {
            this.$notify({
              title: '提示',
              message: res.data.data.msg,
              type: 'success'
            })
          })
        }).catch(() => {

        });

      },
      handleSelectionChange(val) {

        let checkArr = []
        let checkList = []

        var checkNumber={total_fee:0,fee:0,wait:0,success:0,fail:0,accounts_success:0,accounts_fail:0};
        for (let i in val) {
          checkArr.push(val[i].id)
          checkList.push(val[i])
          checkNumber.total_fee+=parseInt(val[i].order_total_fee);
          checkNumber.fee+=parseInt(val[i].platform_service_fee01) + parseInt(val[i].platform_service_fee02)
          if(val[i].check_status == 'WAIT'){
              checkNumber.wait+=1;
          }
          if(val[i].check_status == 'SUCCESS'){
              checkNumber.success+=1;
          }
          if(val[i].check_status == 'FAIL'){
              checkNumber.fail+=1;
          }
          if(val[i].settle_accounts_status== '已入账'){
            checkNumber.accounts_success+=1;
          }
          if(val[i].settle_accounts_status== '未入账'){
            checkNumber.accounts_fail+=1;
          }
        }
        this.checkArr = checkArr
        this.checkList = checkList
        //总计

        this.checkNumber=checkNumber;
        this.checkNumber.order_total =checkArr.length ;

      },

      getDataList() {
        this.loading = true;
        getMerchantAccountChecking(this.params)
          .then((response) => {
            this.dataList = response.data.data.list;
            this.total_count = response.data.data.total_count;
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$message({
              type: "error",
              message: "获取列表信息出错",
            });
          });
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num;
        this.getDataList();
      },
      searchData() {
        this.params.page = 1;
        this.getDataList();
      },
      handleSizeChange(pageSize) {
        this.params.page = 1;
        this.params.pagesize = pageSize;
        this.getDataList();
      },
      show(row) {
        this.dialogFormVisible = true;
        this.row = row;
      },
      getQueryReserveFundBalanceData(){
        this.balance=0;
        getQueryReserveFundBalance({}).then((res) => {
          if (res.data.data.status == true) {
             this.balance = res.data.data.data.balance
          }
        })
      },
      getQueryVSPFundData(){
        this.vps={
          balance:0,
        }
        getQueryVSPFund({}).then((res) => {
          if (res.data.data.status == true) {
             this.vps = res.data.data.data
          }
        })
      },
      //账单校对
      toCheckAccount(row){
          this.$confirm('是否确认重新校对？')
          .then(_ => {
            checkAccount({id:row.id}).then((res) => {
            if (res.data.data.status == true) {
                this.$message({
                type: "success",
                message: res.data.data.msg,
              });
              setTimeout(()=>{
                 this.params.page = 1;
                 this.params.pagesize = pageSize;
                 this.getDataList();
              },2000)
            }else{
                this.$message({
                type: "error",
                message: "校对失败",
              });
            }

        })
            done();

          })
          .catch(_ => {

          });
      }
    },
    mounted() {
      console.log(this.$route.query)
      if (this.$route.query) {
        if (this.$route.query.merchant_id != undefined) {
          this.params.merchant_id = this.$route.query.merchant_id
        }
        if (this.$route.query.belong_billing_date != undefined) {
          this.params.belong_billing_date = this.$route.query.belong_billing_date
        }
        if (this.$route.query.verify != undefined) {
          this.params.verify = this.$route.query.verify
        }
        if (this.$route.query.account_status != undefined) {
          this.params.account_status = this.$route.query.account_status
        }
      }
      this.getDataList();
      this.getPaymentList();
      // this.getMerchantFee();
      // this.getQueryReserveFundBalanceData();
      // this.getQueryVSPFundData();
    },
  };
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }
  .account_box{
     width: 49%;
     display: inline-block;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// detail.vue?35a89c2e